var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"id":"navbar"}}),_c('router-view',{attrs:{"id":"router-v"}}),_c('b-modal',{attrs:{"id":"login-modal","hide-footer":"","centered":"","header-border-variant":"white"}},[[_c('div',{staticClass:"login-page-container"},[_c('component-login')],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }